import React from 'react';

/**
 * Production safety net — catches any runtime error in the React tree
 * and shows a calm fallback instead of a white screen.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{
        minHeight: '100vh',
        background: '#050505',
        color: '#F0E8D4',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        textAlign: 'center',
        fontFamily: 'DM Sans, sans-serif',
      }} data-testid="error-boundary-fallback">
        <div style={{ fontFamily: "'Cormorant Display', serif", fontSize: 64, color: '#C8A84B', marginBottom: 16, fontStyle: 'italic' }}>Something went wrong.</div>
        <p style={{ color: '#B8B0A4', maxWidth: 480, lineHeight: 1.6, marginBottom: 32 }}>
          We've logged the issue and our team has been notified. You can refresh the page or head back to the home page.
        </p>
        <div style={{ display: 'flex', gap: 12 }}>
          <button onClick={this.reset} style={{
            background: '#C8A84B', color: '#07070A', border: 'none', padding: '14px 32px',
            fontSize: 11, fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase',
            borderRadius: 50, cursor: 'pointer',
          }} data-testid="error-boundary-reload">Reload Page</button>
          <a href="/" style={{
            color: '#B8B0A4', border: '1px solid rgba(255,255,255,0.12)', padding: '13px 30px',
            fontSize: 11, fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase',
            borderRadius: 50, textDecoration: 'none',
          }} data-testid="error-boundary-home">Go Home</a>
        </div>
        {process.env.NODE_ENV === 'development' && this.state.error && (
          <pre style={{ color: '#ff8a8a', marginTop: 32, fontSize: 11, maxWidth: 720, overflow: 'auto', textAlign: 'left' }}>
            {String(this.state.error?.stack || this.state.error)}
          </pre>
        )}
      </div>
    );
  }
}
